import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { BlueFrameBox } from "../../Borders/BlueFrameBoxes/BlueFrameBox";
export const Header2 = styled.h2 `
    word-wrap: break-word;
  `;
export function Header({ text }) {
    return (_jsx(BlueFrameBox, { children: _jsx(Header2, { children: text }) }));
}
